export const BUSINESS_FOOTER_US_ID = '5zo6WzCDUIpezS6ODaYU4A'
export const BUSINESS_FOOTER_UK_ID = '5m1zxp97jhi0O96SH5dwGQ'
